import { IAggFuncParams } from '@ag-grid-community/core';

import { decimalAdd, decimalDivide, decimalMultiply } from '@shared/utils';

import { QuarterCloseAdjustmentGridData } from '../quarter-close-adjustments.model';

export class ImaAggTableService {
  static aggregateInvoicesAvailable(params: IAggFuncParams<QuarterCloseAdjustmentGridData>) {
    // Vendor lvl, sum all aggregated values
    if (params.rowNode?.field === 'vendorName') {
      let invoices_available = 0;

      params.values.forEach((value) => {
        if (value) {
          invoices_available += value;
        }
      });

      return invoices_available;
    }

    return params.values[0];
  }

  static aggregateMonthlyVendorPercentComplete(
    params: IAggFuncParams<QuarterCloseAdjustmentGridData>
  ) {
    let total_amount = 0;
    let vendor_estimate_amount = 0;

    params.values.forEach((value) => {
      if (value && value.total_amount) {
        total_amount += value.total_amount || 0;
      }

      if (value && value.vendor_estimate_amount) {
        vendor_estimate_amount += value.vendor_estimate_amount || 0;
      }
    });

    const vendor_estimate_percentage = total_amount
      ? decimalMultiply(decimalDivide(vendor_estimate_amount, total_amount), 100, 6)
      : 0;

    return {
      toString: () => vendor_estimate_percentage.toString(),
      total_amount,
      vendor_estimate_amount,
      vendor_estimate_percentage,
    };
  }

  static aggregateTotalMonthlyCompletePercent(
    params: IAggFuncParams<QuarterCloseAdjustmentGridData>
  ) {
    let total_amount = 0;
    let total_monthly_expense = 0;

    params.values.forEach((value) => {
      if (value && value.total_amount) {
        total_amount += value.total_amount || 0;
      }

      if (value && value.total_monthly_expense) {
        total_monthly_expense += value.tma_amount || 0;
      }
    });

    const tma_percentage = total_amount
      ? decimalMultiply(decimalDivide(total_monthly_expense, total_amount), 100, 6)
      : 0;

    return {
      tma_percentage,
      toString: () => tma_percentage.toString(),
      total_amount,
      total_monthly_expense,
    };
  }

  static aggregateVendorEstimatePercentLtd(params: IAggFuncParams<QuarterCloseAdjustmentGridData>) {
    let total_amount = 0;
    let actualsToDate = 0;
    let vendor_estimate_amount = 0;
    let previous_months_accruals = 0;

    params.values.forEach((value) => {
      if (value && value.total_amount) {
        total_amount += value.total_amount;
      }

      if (value && value.actualsToDate) {
        actualsToDate += value.actualsToDate;
      }

      if (value && value.vendor_estimate_amount) {
        vendor_estimate_amount += value.vendor_estimate_amount;
      }

      if (value && value.previous_months_accruals) {
        previous_months_accruals += value.previous_months_accruals;
      }
    });

    const vendor_estimate_percent_ltd = total_amount
      ? decimalMultiply(
          decimalDivide(
            decimalAdd(
              decimalAdd(actualsToDate || 0, vendor_estimate_amount),
              previous_months_accruals
            ),
            total_amount
          ),
          100,
          6
        )
      : 0;

    return {
      actualsToDate,
      previous_months_accruals,
      toString: () => vendor_estimate_percent_ltd.toString(),
      total_amount,
      vendor_estimate_amount,
      vendor_estimate_percent_ltd,
    };
  }
}
